import type { FeatureTourAvatarConfig, FeatureTourConfig, FeatureTourStepsConfig } from '../../model/store/interfaces'

import DisciplineMenuGif from '../../ui/images/home-product-onboarding/home-product-onboarding-desktop-1.gif'
import DisciplineMenuGifTablet from '../../ui/images/home-product-onboarding/home-product-onboarding-tablet-1.gif'
import DisciplineMenuGifMobile from '../../ui/images/home-product-onboarding/home-product-onboarding-mobile-1.gif'
import UnscheduledLessonsGif from '../../ui/images/home-product-onboarding/home-product-onboarding-desktop-2.gif'
import UnscheduledLessonsGifTablet from '../../ui/images/home-product-onboarding/home-product-onboarding-tablet-2.gif'
import UnscheduledLessonsGifMobile from '../../ui/images/home-product-onboarding/home-product-onboarding-mobile-2.gif'
import ChangeTutorGif from '../../ui/images/home-product-onboarding/home-product-onboarding-desktop-3.gif'
import ChangeTutorGifTablet from '../../ui/images/home-product-onboarding/home-product-onboarding-tablet-3.gif'
import ChangeTutorGifMobile from '../../ui/images/home-product-onboarding/home-product-onboarding-mobile-3.gif'
import BtnMoreGif from '../../ui/images/home-product-onboarding/home-product-onboarding-desktop-4.gif'
import BtnMoreGifTablet from '../../ui/images/home-product-onboarding/home-product-onboarding-tablet-4.gif'
import BtnMoreGifMobile from '../../ui/images/home-product-onboarding/home-product-onboarding-mobile-4.gif'
import BtnSupportGif from '../../ui/images/home-product-onboarding/home-product-onboarding-desktop-5.gif'
import BtnSupportGifTablet from '../../ui/images/home-product-onboarding/home-product-onboarding-tablet-5.gif'
import BtnSupportGifMobile from '../../ui/images/home-product-onboarding/home-product-onboarding-mobile-5.gif'

const HOME_TOUR_ID = 'home-product-onboarding' as const

export const HOME_TOUR_STEPS = {
  AVATAR: `${HOME_TOUR_ID}:avatar`,
  DISCIPLINE_MENU: `${HOME_TOUR_ID}:discipline-menu`,
  UNSCHEDULED_LESSONS: `${HOME_TOUR_ID}:unscheduled-lessons`,
  CHANGE_TUTOR: `${HOME_TOUR_ID}:change-tutor`,
  BTN_MORE: `${HOME_TOUR_ID}:btn-more`,
  BTN_SUPPORT: `${HOME_TOUR_ID}:btn-support`,
} as const

export const homeTourAvatarConfig: FeatureTourAvatarConfig = {
  id: HOME_TOUR_STEPS.AVATAR,
}

export const homeTourStepsConfig: FeatureTourStepsConfig = {
  id: HOME_TOUR_ID,
  steps: [
    {
      variant: 'welcome',
      spotId: HOME_TOUR_STEPS.AVATAR,
      title: 'Let’s explore the platform 👀',
      description: 'Everything you need to manage your child’s learning is right here!',
      buttonText: 'Take a tour',
      hideBorder: true,
      placement: 'top',
    },
    {
      spotId: HOME_TOUR_STEPS.DISCIPLINE_MENU,
      title: 'Program pages',
      description: 'Each program has its own page. Schedule or reschedule lessons, view past classes, and share files with your tutor — all in one place.',
      image: DisciplineMenuGif,
      imageTablet: DisciplineMenuGifTablet,
      imageMobile: DisciplineMenuGifMobile,
      highlightPadding: {
        mobile: 8,
        tablet: 16,
        desktop: 16,
      },
      mobilePlacement: 'bottom',
      tabletPlacement: 'bottom',
      placement: 'bottom',
    },
    {
      spotId: HOME_TOUR_STEPS.UNSCHEDULED_LESSONS,
      title: 'Schedule unused lessons',
      description: 'Canceled a lesson in advance? It moves to your unscheduled balance. Click “Schedule” to choose a new date and time outside your regular schedule.',
      image: UnscheduledLessonsGif,
      imageTablet: UnscheduledLessonsGifTablet,
      imageMobile: UnscheduledLessonsGifMobile,
      imageHeight: {
        mobile: 185,
      },
      mobilePlacement: 'top',
      tabletPlacement: 'bottom',
      placement: 'left-start',
    },
    {
      spotId: HOME_TOUR_STEPS.CHANGE_TUTOR,
      title: 'Meet your tutor!',
      description: 'See who your tutor is and view their profile. Want to try someone else? You can request a tutor change anytime.',
      image: ChangeTutorGif,
      imageTablet: ChangeTutorGifTablet,
      imageMobile: ChangeTutorGifMobile,
      imageHeight: {
        mobile: 190,
      },
      mobilePlacement: 'top',
      tabletPlacement: 'top',
      placement: 'left',
    },
    {
      spotId: HOME_TOUR_STEPS.BTN_MORE,
      title: 'Manage Subscriptions & Profile',
      description: 'Find subscription management and profile settings under “More”',
      image: BtnMoreGif,
      imageTablet: BtnMoreGifTablet,
      imageMobile: BtnMoreGifMobile,
      highlightPadding: {
        mobile: 7,
      },
      mobilePlacement: 'top',
      placement: 'bottom',
    },
    {
      spotId: HOME_TOUR_STEPS.BTN_SUPPORT,
      title: 'Quick Support',
      description: 'Need help? Contact our team instantly — we’re here for you',
      buttonText: 'Got it!',
      image: BtnSupportGif,
      imageTablet: BtnSupportGifTablet,
      imageMobile: BtnSupportGifMobile,
      highlightPadding: {
        mobile: 7,
      },
      mobilePlacement: 'top',
      placement: 'bottom',
    },
  ],
}

export const homeTourConfig: FeatureTourConfig = {
  avatarConfig: homeTourAvatarConfig,
  stepsConfig: homeTourStepsConfig,
  finishedSettingsKey: 'product_tour_finished_at',
}

const homeTourProgressStepsConfig: FeatureTourStepsConfig = {
  id: HOME_TOUR_ID,
  steps: homeTourStepsConfig.steps
    .filter((step) => step.spotId !== HOME_TOUR_STEPS.UNSCHEDULED_LESSONS)
    .map((step) => step.spotId === HOME_TOUR_STEPS.CHANGE_TUTOR ? { ...step, placement: 'bottom' } : step),
}

export const homeTourProgressConfig: FeatureTourConfig = {
  ...homeTourConfig,
  stepsConfig: homeTourProgressStepsConfig,
}
